<template>
    <div :name="`name${data.qid}`"  class="test_question list">
        <p class="title" 
            :class="{'required':data.mustanswer}"
            :style="{
                fontSize: bandingstyle.appearancePhone.fontStemSize+'px',
                color:bandingstyle.appearancePhone.fontStemColor,
                fontWeight: bandingstyle.appearancePhone.fontStemBold,
                fontStyle: bandingstyle.appearancePhone.fontStemItalic,
                textDecoration: bandingstyle.appearancePhone.fontStemUnderline
            }"
        ><span v-if="showTitleNum == 1">{{data.quesIndex + 1}}、</span><span v-html="data.questionsName"></span></p>
        
        <div>
            <div class="input_box"> 
                <el-input
                    :class="{'input__err': data.validate}"
                    v-if="data.questionsTypeId == 204 || data.questionsTypeId == 206"
                    resize="none"
                    type="textarea"
                    :rows="data.inputHeight == '小' ? 1 : (data.inputHeight == '中' ? 2 : 3)"
                    v-model="data.userAnswer">
                </el-input>
                <div v-show="data.validate" class="form-item__error">{{data.validateMsg}}</div>
            </div>
            <template v-if="data.questionsTypeId == 207">
                <div 
                    class="multiple" 
                    v-for="item in data.optionList" :key="item.oid"
                    :style="{
                        fontSize: bandingstyle.appearancePhone.fontOptionSize+'px !important',
                        color:bandingstyle.appearancePhone.fontOptionColor,
                        fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                        fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                        textDecoration: bandingstyle.appearancePhone.fontOptionUnderline,
                    }"
                >
                    <p class="item-title"><span v-html="item.labelName"></span></p>
                    <div class="input_box"> 
                        <el-input
                            :class="{'input__err': item.validate}"
                            class="item-input"
                            resize="none"
                            type="textarea"
                            :rows="item.inputHeight == '小' ? 1 : (item.inputHeight == '中' ? 2 : 3)"
                            v-model="item.userAnswer">
                        </el-input>
                    
                        <div v-show="item.validate" class="form-item__error">{{item.validateMsg}}</div>
                    </div>
                </div>
            </template>
            <template v-if="data.questionsTypeId == 208">
                <div
                    class="stem"
                    :style="{
                        fontSize: bandingstyle.appearancePhone.fontOptionSize+'px !important',
                        color:bandingstyle.appearancePhone.fontOptionColor,
                        fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                        fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                        textDecoration: bandingstyle.appearancePhone.fontOptionUnderline,
                    }"
                    
                >
                    <template v-for="(info, index) in questionOption">
                        <span v-if="typeof info == 'string'" v-html="info" :key="index"></span>
                        <div  v-else class="input_box-border" :key="index" > 
                            <input 
                                :class="{'input__horizontal__err': data.optionList[info.index].validate}"
                                v-model="data.optionList[info.index].userAnswer" 
                                type="text" 
                                :style="`display: inline-block;width:${info.width}px;border: none;border-bottom: 1px solid;outline: none;text-align: center;`">
                        </div>
                    </template>
                    <template v-for="val in data.optionList">
                        <div :key="val.oid" 
                            v-show="val.validate" 
                            class="form-item__error">{{val.validateMsg}}
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {},
        bandingstyle:{},
        showTitleNum:{
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            checkList: [],
            questionOption: []
        }
    },
    watch:{
        'data':{
            handler(newV) {
                if (this.data.questionsTypeId == 207 || this.data.questionsTypeId == 208) {
                    let result = false
                    if (this.data.optionList.length > 0) {
                        this.data.optionList.forEach((info) => {
                            if (info.userAnswer) {
                                result = true
                            }
                        })
                    }
                    if (result) {
                        newV.userAnswer = 1
                    } else {
                        newV.userAnswer = 0
                    }
                }
            },
            deep: true
        },
        'data.questionsTypeId': {
            handler(newV) {
                // console.log('data.optionList')
                if (newV == 208){
                    this.questionOption = []
                    let str = this.data.quesOptionTitle
                    let arr = str.match(/_[_]+_/g)
                    
                    for(let i in arr){
                        let obj = JSON.stringify({width:arr[i].length * 10,})
                        str = str.replace(arr[i],`^${obj}^`)
                    }
                    let arrData = str.split('^')
                    for(let i in arrData){
                        if(arrData[i]){
                            this.questionOption.push(this.$functions.isJSON(arrData[i]) ? JSON.parse(arrData[i]) : arrData[i])
                        }
                    }
                    let index = 0
                    this.questionOption = this.questionOption.map((info) =>{
                        if((typeof info) != 'string'){
                            info.index = index
                            index++
                        } else {
                            info = this.$functions.HTMLClosedOrNot(info)
                        }
                        return info
                    })
                    // console.log(this.questionOption)
                    // console.log(this.data.optionList)
                } else if(newV == 204 || newV == 206){
                    if (!this.data.userAnswer) {
                            this.data.userAnswer = this.data.placeholder
                        }
                } else if(newV == 207) {
                    this.data.optionList.forEach( (info) =>{
                        // console.log(info)
                        if (!info.userAnswer) {
                            info.userAnswer = info.placeholder
                        }
                    })
                }
            },
            immediate: true
        }
    },
    created() {
        
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.test_question{
    .title{
        margin-bottom: 10px;
        display: flex;
        word-break: break-all;
    }
    .option-box{
        display: flex;
        flex-direction: column;
        padding-left: 25px;
        .option+.option{
            margin-top: 10px;
        }
    }
}
.required::before{
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
.form-item__error{
    color: #f56c6c;
}
.input__horizontal__err{
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    border-bottom: 1px solid #f56c6c !important;
}
/deep/.input__err>.el-textarea__inner{
    border-color: #f56c6c;
}
.input_box{
    width: 100%;
    display: inline-block;
}
.input_box-border{
    display: inline-block;
}
.list{
    .multiple{
        padding-left: 10px;
        .item-title{
            font-size: 14px;
            margin-bottom: 15px;
        }
    }
    .multiple+.multiple{
        margin-top: 15px;
    }
    .stem{
        padding-left: 10px;
        font-size: 14px;
        line-height: 30px;
    }
}
</style>